// imageUtils.js - Utility functions for handling images

export const testImageLoad = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      console.log(`✅ Image loaded successfully: ${url}`);
      resolve(true);
    };
    img.onerror = () => {
      console.error(`❌ Failed to load image: ${url}`);
      reject(false);
    };
    img.src = url;
  });
};

export const validateImageUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch (e) {
    console.error(`❌ Invalid URL: ${url}`, e);
    return false;
  }
};

export const getImageDimensions = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
        url: url
      });
    };
    img.onerror = () => {
      reject(new Error(`Failed to load image: ${url}`));
    };
    img.src = url;
  });
};

export const testAllRecognitionImages = async (recognitions) => {
  console.log(`🔍 Testing ${recognitions.length} recognition images...`);
  
  const results = await Promise.allSettled(
    recognitions.map(async (recognition, index) => {
      // Handle both object and string formats
      const imageUrl = typeof recognition === 'string' ? recognition : recognition.image;
      
      if (!imageUrl) {
        return { index, url: imageUrl, status: 'no-url', error: 'No image URL found' };
      }
      
      const isValidUrl = validateImageUrl(imageUrl);
      if (!isValidUrl) {
        return { index, url: imageUrl, status: 'invalid-url', error: 'Invalid URL format' };
      }
      
      try {
        await testImageLoad(imageUrl);
        const dimensions = await getImageDimensions(imageUrl);
        return { 
          index, 
          url: imageUrl, 
          status: 'success', 
          dimensions,
          description: typeof recognition === 'object' ? recognition.description : null
        };
      } catch (error) {
        return { 
          index, 
          url: imageUrl, 
          status: 'failed', 
          error: error.message 
        };
      }
    })
  );

  const successful = results.filter(r => r.value?.status === 'success').length;
  const failed = results.filter(r => r.value?.status === 'failed').length;
  const invalid = results.filter(r => r.value?.status === 'invalid-url').length;
  const noUrl = results.filter(r => r.value?.status === 'no-url').length;

  console.log(`📊 Recognition Images Test Results:
    ✅ Successful: ${successful}
    ❌ Failed: ${failed}
    🚫 Invalid URLs: ${invalid}
    ⚠️ No URL: ${noUrl}
  `);

  results.forEach(result => {
    if (result.status === 'fulfilled' && result.value.status !== 'success') {
      console.error(`❌ Image ${result.value.index}: ${result.value.error}`, result.value.url);
    } else if (result.status === 'fulfilled' && result.value.status === 'success') {
      console.log(`✅ Image ${result.value.index}: ${result.value.dimensions.width}x${result.value.dimensions.height}`, result.value.url);
    }
  });

  return results;
};
